// removed by extract-text-webpack-plugin
module.exports = {"base":"Stronghold_base--2OVAJ","ratings":"Stronghold_ratings--1UD0N","back":"Stronghold_back--37kJN"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/Stronghold.scss
// module id = 2214
// module chunks = 11